/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_Attach_SubmitInputs */

const vi_camera_station_attach_submit = /** @type {(inputs: Camera_Station_Attach_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gắn vào trạm này`)
};

/**

* @param {Camera_Station_Attach_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_attach_submit = /** @type {((inputs?: Camera_Station_Attach_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_Attach_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_attach_submit(inputs)
});